import React, {  Component } from 'react';
import { connect } from 'react-redux';
import {
	getSearchKeywordSuggestionList,
	checkPricesForSearchResult,
} from '../../../redux/actions';

import moment from 'moment';
import _ from 'lodash';

import { routes } from '../../../redux/api/routes';
const { getItemsCount } = routes;
import { processPricingResponse } from '../../../redux/util';

class AccountNumberAutoSuggests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuggestion: false,
            showSearchLoading: false,
            productName: this.props.value?this.props.value:'',
            productNumberList: null,
            // productCount: 5,

			isAvailabilityCallCompleted: false,
			isPricingCallCompleted: false,
			isImportedFromFile: false,
			isAddressChanged: false,

			pricingCache: [],
			isPNETOrNCRP: props.searchContext && ['PNET', 'NCRP'].includes(props.searchContext),
			selectedSuggestedItemIndex: null
        }
		this.handleChangeProductNumber = this.handleChangeProductNumber.bind(this);
		this.fetchAvailabilityAndPricing = this.fetchAvailabilityAndPricing.bind(this);
		this.getCount = this.getCount.bind(this);
		this.searchTimeoutId = null;
    }

	getCount() {
		const self = this;
		return self.props.whichPage === "quickorder" ? "" : `&count=${getItemsCount}`;
	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		if(self.props.isImportedFromFile && !self.state.isImportedFromFile) {
			self.setState({
				productName: nextProps.value,
				isImportedFromFile: self.props.isImportedFromFile
			}, () => {
				self.handleChangeProductNumber({
					target: {
						value: nextProps.value
					}
				})
			});
		}
		if(nextProps.isAddressChanged && !self.state.isAddressChanged) {
			self.setState({
				isAddressChanged: true,
			}, () => {
				const availabilityOnChangeAddress = JSON.parse(JSON.stringify(self.props.state.order.availabilityOnChangeAddress));
				const data = self.state.isPNETOrNCRP ? availabilityOnChangeAddress.find(itm => self.props.itemDetails.id === itm.id && self.state.productName === itm.sku) :
					availabilityOnChangeAddress.find(itm => self.state.productName === itm.sku);
				let availabilityData = [];
				if (data) {
					availabilityData = data.availabilityData;
				}
				const productNumberList = [];
				self.state.productNumberList && self.state.productNumberList.responseObject && self.state.productNumberList.responseObject.forEach((item) => {
					if(item.sku === self.state.productName) {
						productNumberList.push({
							...item,
							availabilityData
						});
					}
				});
				self.setState({
					availabilityData,
					bkpAvailabilityData: self.state.isPNETOrNCRP ? self.state.bkpAvailabilityData : JSON.parse(JSON.stringify(availabilityData)),
					productNumberList: {
						...self.state.productNumberList,
						responseObject: productNumberList
					},
					// pricingData,
					// isImportedFromFile: false,
					// isStillImportedFromFile: true,
					isAvailabilityCallCompleted: true,
					isPricingCallCompleted: true,
				}, () => {
					// As we have imported files from we will have already saved availability and pricing
					self.callBackAfterAvailabilityAndPricing(self.state.productName);
				});
			});
		} else if (!nextProps.isAddressChanged) {
			self.setState({
				isAddressChanged: false,
			});
		}
	}

	componentDidMount() {
		this.props.setChangeMethod && this.props.setChangeMethod(this.handleChangeProductNumber, this.suggestInput);
		if (this.state.isPNETOrNCRP && this.props.isNewItem) {
			this.handleChangeProductNumber({
				target: {
					value: this.props.value
				}
			})
		}
	}

	componentWillUnmount() {
		this.searchTimeoutId && clearTimeout(this.searchTimeoutId);
	}

	partSearchFailedWithErrors = errors => {
		this.setState({
			partSearchErrorMessages: errors,
			showSearchLoading: false,
			productNumberList: {
				status: true,
				responseObject: []
			}
		})
	}

    handleChangeProductNumber(event) {
        var self = this;
        var value = self.state.isPNETOrNCRP ? event.target.value.trim() : event.target.value;
		let itemDet = self.props.itemDetails;

        self.setState({
			showSearchLoading: false,
			showSuggestion: false,
			productName: value.toUpperCase(),
			productNumberList: !self.state.isPNETOrNCRP && (event.onChangeOfQuantity || event.onChangeOfSalesAgreement) ? self.state.productNumberList : null,
			isAvailabilityCallCompleted: false,
			isPricingCallCompleted: false,
			availabilityData: null,
			pricingData: null,
			onChangeOfSalesAgreement: event.onChangeOfSalesAgreement,
			onChangeOfQuantity: event.onChangeOfQuantity,
			partSearchErrorMessages: [],
			selectedSuggestedItemIndex: (event.onChangeOfSalesAgreement || event.onChangeOfQuantity) ? self.state.selectedSuggestedItemIndex : null
		}, () => {
			if(self.state.isImportedFromFile || self.props.isNewItem) {
				if(self.state.isPNETOrNCRP) {
					const availabilityPricingOfImportedFile = JSON.parse(JSON.stringify(self.props.state.order.availabilityPricingOfImportedFile));
					const data = availabilityPricingOfImportedFile.find(availabilityPricingItem => availabilityPricingItem.id === itemDet.id && availabilityPricingItem.itemNumber === value.toUpperCase());
					let availabilityData = [],
						pricingData = [];
					if (data) {
						availabilityData = data.availabilityData || [];
						pricingData = data.pricingData || [];
					}
					self.setState({
						suggstionList: {
							responseObject: [{
								sku: value
							}],
							keyword: `${value.toUpperCase()}*`,
							status: true
						},
						availabilityData,
						pricingData,
						bkpPricingData: JSON.parse(JSON.stringify(pricingData)),
						isAvailabilityCallCompleted: true,
						isPricingCallCompleted: true,
					}, () => {
						// As we have imported files from we will have already saved availability and pricing
						self.callBackAfterAvailabilityAndPricing(value);
					});
				} else {
					const availabilityPricingOfImportedFile = JSON.parse(JSON.stringify(self.props.state.order.availabilityPricingOfImportedFile));
					const data = availabilityPricingOfImportedFile.find(itm => value === itm.sku && itm.agreementNumber === itemDet.agreementNumber);
					let pricingDataArr = [];
					availabilityPricingOfImportedFile.map(item => {
						item.pricingData && item.pricingData.items && item.pricingData.items.map(itm => {
							let rec = itm.records && itm.records.filter(it => it.sa_number === itemDet.agreementNumber.toString() && value === it.item_number);
							if(rec && rec.length > 0) {
								pricingDataArr.push(itm);
							}
						})
					});
					let availabilityData = [],
						pricingData = [];
					if (data) {
						availabilityData = data.availabilityData || [];
						pricingData = data.pricingData || [];
					}
					self.setState({
						suggstionList: {
							responseObject: [{
								sku: value
							}],
							keyword: `${value.toUpperCase()}*`,
							status: true,
							overpackQuantityRequired: itemDet.overpackQuantityRequired,
							packageQuantity: itemDet.packageQuantity
						},
						availabilityData,
						bkpAvailabilityData: JSON.parse(JSON.stringify(availabilityData)),
						pricingData,
						bkpPricingData: JSON.parse(JSON.stringify(pricingData)),
						isImportedFromFile: false,
						isStillImportedFromFile: true,
						isAvailabilityCallCompleted: true,
						isPricingCallCompleted: true,
					}, () => {
						// As we have imported files from we will have already saved availability and pricing
						self.callBackAfterAvailabilityAndPricing(value);
					});
				}
			} else {
				//Reset error on change of text box
				self.props.onChangeProductNumberTextBox && self.props.onChangeProductNumberTextBox(self.props.itemIndex, value, null, false);
		        if(value !== "" && value.length > 2) {
		            self.setState({
						isStillImportedFromFile: false,
						showSearchLoading: self.state.onChangeOfSalesAgreement || self.state.onChangeOfQuantity ? false : true,
						showSuggestion: self.state.onChangeOfSalesAgreement || self.state.onChangeOfQuantity ? false : true
					}, () => {
						if((self.state.onChangeOfSalesAgreement || self.state.onChangeOfQuantity) && self.state.suggstionList) {
							self.setState({
								suggstionList: self.state.suggstionList,
								isStillImportedFromFile: false,
							}, () => {
								// Add pricing service call and availability service call
								const skuList = self.state.isPNETOrNCRP ? self.state.suggstionList.responseObject : self.state.suggstionList.responseObject.map(itm => ({sku: itm.sku, itemType: (itm.itemType || 'M')}));
								self.fetchAvailabilityAndPricing(skuList, value, true);
							});
						} else {
							if(self.state.isPNETOrNCRP) {
								self.searchTimeoutId && clearTimeout(self.searchTimeoutId);
								const agreementNumber = (itemDet && itemDet.agreementNumber) || self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER;

								self.searchTimeoutId = setTimeout(() => {
									const itemNumber = value.toUpperCase();

									self.props.getItemDetails(
										{
											items: [
												{
													id: itemDet.id,
													itemNumber,
													requestedQuantity: itemDet.requestedQuantity || itemDet.quantity,
													requestedShipDate: self.props.requestedShipDate
												}
											],
											agreementNumber,
											shipSet: self.props.shipSet
										},
										data => {
											if (self.props.value.toUpperCase() !== value.toUpperCase()) {
												return;
											}
											const errors = [];
									
											const validItems = data.items.filter(item => {
												if (item.isInvalid) {
													errors.push(`Item ${item.itemNumber} is Invalid`);
												} else if (item.isNLA) {
													errors.push(`Item ${item.itemNumber} is No Longer Available`);
												} else if (item.isPOKInstall) {
													errors.push(`${item.itemNumber} is a POK item`);
												} else if (item.isInvalidSupersedure) {
													errors.push(`Invalid supersedure`);
												} else if (self.props.searchContext === 'NCRP' && !['PART', 'ACCESSORY'].includes(item.itemType)) {
													errors.push(`Item ${item.itemNumber} is not a Part/Accessory`);
												} else {
													if (item.isRestricted) {
														errors.push(`Item ${item.itemNumber} is Restricted${item.restrictionReason ? ` - ${item.restrictionReason}` : ''}`);
													} else {
														if (
															self.props.searchContext !== 'NCRP' &&
															!(item.pricingData && item.pricingData.records && item.pricingData.records.length && item.pricingData.records[0].unitPrice)
														) {
															errors.push(`Item ${item.itemNumber} is not in Price List`);
														} else {
															if (self.props.shipSet === '1') {
																return true;
															} else {
																if (item.availabilityData && item.availabilityData.errorCode !== 80 && item.availabilityData.sourceOrganizationID) {
																	return true;
																} else {
																	if (item.availabilityData && (item.availabilityData.errorCode === 80 || !item.availabilityData.sourceOrganizationID)) {
																		errors.push(`Item ${item.itemNumber} cannot be ordered from this warehouse`);
																	} else {
																		errors.push(`Item ${item.itemNumber} is not Available`);
																	}
																}
															}
														}
													}
												}
												return false;
											});
									
											if (validItems.length) {
												self.setState(
													{
														showSearchLoading: false,
														showSuggestion: false
													},
													() => {
														self.props.updateQuickOrderState(self.props.itemIndex, validItems);
													}
												);
											} else {
												self.partSearchFailedWithErrors(errors);
											}
										},
										{
											searchContext: self.props.searchContext,
											include:
												self.props.shipSet === '1'
													? { pim: true, orderability: true, pricing: true }
													: self.props.searchContext === 'NCRP'
													? { pim: true, availability: true, orderability: true }
													: { pim: true, availability: true, orderability: true, pricing: true }
										}
									);
								}, 500)
								return;
							}
							self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${value}${self.getCount()}`, response => {
								if(self.suggestInput && self.suggestInput.value.toUpperCase() === response.keyword.toUpperCase().replace('*','')) {
									self.setState({
										suggstionList: response,
										isStillImportedFromFile: false,
									}, () => {
										// Add pricing service call and availability service call
										const skuList = response.responseObject.map(itm => ({sku: itm.sku, itemType: (itm.itemType || 'M')}));
										self.fetchAvailabilityAndPricing(skuList, value, self.state.onChangeOfSalesAgreement);
									});
								}
				            });
						}
					});
		        }
			}
		});
    }

	checkOrderAvailability = (itemDetails, callback) => {
		const { itemIndex, doNotSelectHeaderSelectedADC } = this.props;
		const { selectedAccount, selectedAddress: selectedAddressString } = this.props.state.user;
		const selectedAddress = JSON.parse(selectedAddressString || '{}');
		const accountNumber = selectedAccount.ACCOUNTNUMBER;
		let zipCode = selectedAddress ? selectedAddress.POSTALCODE.split('-')[0] : '';
		if (this.props.zipCode) {
			zipCode = this.props.zipCode;
		}
		
		zipCode && this.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
			if(resp && resp.agentid) {
				const orderAvailabilityPayload = {
					accountNumber,
					warehouseCode: resp.agentid,
					customerSiteId: selectedAddress.addressId ? selectedAddress.addressId :selectedAddress.SITE_USE_ID,
					requestedDeliveryDate: moment().format('MM/DD/YYYY'),
					orderSource: '',
					zipCode,
					state: selectedAddress.STATE,
					country: selectedAddress.COUNTRY,
					tradingPartnerId:'',
					dateType:'SHIP',
					items: null
				};
				if (!Array.isArray(itemDetails)) {
					const existingAvailabilityData = this.state.bkpAvailabilityData && this.state.bkpAvailabilityData.find(availabilityItem => availabilityItem.sku === itemDetails.productName);
					// If warehouseCode or agreementNumber are not matching or requested date quantity is less than required quantity, we need to call order availability again, or else use the cached one
					if (existingAvailabilityData && existingAvailabilityData.warehouseCode === resp.agentid && existingAvailabilityData.agreementNumber === (itemDetails.agreementNumber && itemDetails.agreementNumber.toString()) && existingAvailabilityData.availableQty >= +itemDetails.qty) {
						let updatedItemAvailability = { ...existingAvailabilityData, orderQty: itemDetails.qty.toString() };
						const availabilityData = this.state.bkpAvailabilityData && this.state.bkpAvailabilityData.map(availabilityItem => availabilityItem.sku === this.state.productName ? updatedItemAvailability : availabilityItem);
						callback(availabilityData);
					} else {
						// Call Order Availability if quantity is present
						orderAvailabilityPayload.items = [{
							itemNumber: itemDetails.productName,
							identifier: itemIndex + 1,
							qty: itemDetails.qty,
							shipMethod: 'ADC Truckload',
							arrivalSetName: '',
							itemType: '',
							demandClass: this.props.getSalesAgreementParamForAvailability(itemDetails.agreementNumber ? itemDetails.agreementNumber.toString() : '').split("=")[1],
							overrideFlag: 'N',
							quantityUOM: 'EA',
							finalProductionDate: itemDetails.productDetails && (itemDetails.productDetails.finalProductionDate ? moment(itemDetails.productDetails.finalProductionDate).format('MM/DD/YYYY') : itemDetails.productDetails.finalProductionDate),
							agreementNumber: itemDetails.agreementNumber
						}];
						
						this.props.checkAvailabilityForOrder(orderAvailabilityPayload, orderAvailabiityData => {
							let updatedItemAvailability = orderAvailabiityData && this.props.formatOrderAvailabilityData(orderAvailabiityData[0]);
							updatedItemAvailability = { ...updatedItemAvailability, itemType: itemDetails.productDetails && itemDetails.productDetails.itemType };
							const availabilityData = this.state.bkpAvailabilityData && this.state.bkpAvailabilityData.map(availabilityItem => availabilityItem.sku === this.state.productName ? updatedItemAvailability : availabilityItem);
							callback(availabilityData);
						});
					}
				}
			}
		}, false, undefined, undefined, undefined, doNotSelectHeaderSelectedADC)
	}

	fetchAvailabilityAndPricing(skuList, value, showWholeScreenLoader = false) {
		const self = this;
		if(skuList.length > 0) {
			// Make availability call
			const { selectedAccount, selectedPriceSource } = self.props.state.user;
			const accountNumber = selectedAccount.ACCOUNTNUMBER;
			if (self.state.onChangeOfSalesAgreement && self.state.bkpAvailabilityData && !(self.props.itemDetails && self.props.itemDetails.qty)) {
				self.setState({
					isAvailabilityCallCompleted: true,
					availabilityData: JSON.parse(JSON.stringify(self.state.bkpAvailabilityData))
				}, () => {
					self.callBackAfterAvailabilityAndPricing(value);
				});
			} else if (!self.state.isPNETOrNCRP && self.state.onChangeOfSalesAgreement && self.props.itemDetails && self.props.itemDetails.qty) {
				self.checkOrderAvailability(self.props.itemDetails, orderAvailabilityData => {
					self.setState({
						isAvailabilityCallCompleted: true,
						availabilityData: orderAvailabilityData,
						bkpAvailabilityData: JSON.parse(JSON.stringify(orderAvailabilityData)),
					}, () => {
						self.callBackAfterItemOrderabilityAndPricing();
					});
				})
			} else {
				if(self.state.isPNETOrNCRP) {
					const {quantity, requestedShipDate, shipSet, itemDetails, searchContext} = self.props;

					if(self.state.onChangeOfQuantity) {
						self.props.getItemDetails(
							{
								items: [
									{
										id: itemDetails.id,
										itemNumber: itemDetails.itemNumber,
										requestedQuantity: itemDetails.requestedQuantity || quantity,
										requestedShipDate,
										itemType: itemDetails.itemType
									}
								],
								shipSet
							},
							data => {
								self.setState(
									{
										isAvailabilityCallCompleted: true,
										availabilityData: data.items[0].availabilityData ? [data.items[0].availabilityData] : [],
										bkpAvailabilityData: JSON.parse(JSON.stringify(data.items[0].availabilityData ? [data.items[0].availabilityData] : [])),
										isPricingCallCompleted: true,
										pricingData: self.state.bkpPricingData || []
									},
									() => {
										self.callBackAfterAvailabilityAndPricing(value);
									}
								);
							},
							{
								searchContext,
								include: {
									availability: true
								},
								showLoader: true
							}
						);
					}
				} else {
					const { itemDetails, doNotSelectHeaderSelectedADC } = self.props;

					if (itemDetails && itemDetails.qty) {
						self.checkOrderAvailability(itemDetails, orderAvailabilityData => {
							self.setState({
								isAvailabilityCallCompleted: true,
								isPricingCallCompleted: self.state.onChangeOfQuantity,
								pricingData: self.state.onChangeOfQuantity ? self.state.bkpPricingData : null,
								availabilityData: orderAvailabilityData,
								bkpAvailabilityData: JSON.parse(JSON.stringify(orderAvailabilityData))
							}, () => {
								self.callBackAfterItemOrderabilityAndPricing();
							});
						})
					} else {
						const data = JSON.parse(self.props.state.user.selectedAddress);
						let zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						if (self.props.zipCode) {
							zipCode = self.props.zipCode;
						}
						zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
						if(resp && resp.agentid) {
							self.props.checkAvailabilityAndOrderability(skuList, `accountNumber=${accountNumber}&zipCode=${self.props.zipCode}&legacyCustCode=${self.props.legacyCustCode}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, self.props.selectedAddressParams, '', showWholeScreenLoader, response => {
								self.setState({
									isAvailabilityCallCompleted: true,
									availabilityData: response.responseObject,
									bkpAvailabilityData: JSON.parse(JSON.stringify(response.responseObject)),
								}, () => {
									self.callBackAfterAvailabilityAndPricing(value);
								});
							});
						}
						}, false, undefined, undefined, undefined, doNotSelectHeaderSelectedADC);
					}
				}
			}

			if(!self.state.onChangeOfQuantity) {
				let skuListForPricing = skuList.map(item => item.sku);
				if (self.state.onChangeOfSalesAgreement) {
					skuListForPricing = [self.state.productName];
				}
				let agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
				if(self.props.selectedPriceSource) {
					agreementNumber = self.props.selectedPriceSource;
				}
				self.setState({
					skuListForPricing
				}, () => {
					const skuList = [];
					skuListForPricing.forEach(item => {
						if (!self.state.pricingCache.find(itm => itm.agreementNumber === agreementNumber && itm.item === item)) {
							skuList.push(item);
						}
					});
					self.getPricing(skuList, agreementNumber, showWholeScreenLoader, () => {
						const finalPricing = [];
						const { pricingCache } = self.state;
						self.state.skuListForPricing.forEach(item => {
							let data = pricingCache.find(itm => itm.agreementNumber === agreementNumber && itm.item === item);
							data = data && data.pricingData;
							if(!data || data.records.length === 0) {
								data = null;
							} else {
								finalPricing.push(data);
							}
						});
						self.setState({
							isPricingCallCompleted: true,
							pricingData: {
								items: finalPricing
							},
							bkpPricingData: {
								items: JSON.parse(JSON.stringify(finalPricing))
							}
						}, () => {
							if (!self.state.isPNETOrNCRP && self.state.onChangeOfSalesAgreement && self.props.itemDetails && self.props.itemDetails.qty) {
								self.callBackAfterItemOrderabilityAndPricing();
							} else {
								self.callBackAfterAvailabilityAndPricing(value);
							}
						});
					});
				});
			}
		} else {
			self.setState({
				isAvailabilityCallCompleted: true,
				availabilityData: [],
				isPricingCallCompleted: true,
				pricingData: [],
				bkpPricingData: []
			}, () => {
				self.callBackAfterAvailabilityAndPricing(value);
			});
		}
	}

	updatePricingCache = (agreementNumber, pricingResponse, callback) => {
		const pricingCache = JSON.parse(JSON.stringify(this.state.pricingCache));

		pricingCache.forEach(pricingCacheItem => {
			if(pricingCacheItem.agreementNumber === agreementNumber && pricingCacheItem.callInProgress === true) {
				const data = pricingResponse.responseObject.items.find(pricingItem => pricingItem.item_number === pricingCacheItem.item);
				pricingCacheItem.pricingData = data;
				pricingCacheItem.callInProgress = false;
				pricingCacheItem.callCompleted = true;
			}
		});
		this.setState({
			pricingCache
		}, () => {
			callback();
		});
	}

	getPricing(skuList, agreementNumber, showWholeScreenLoader, callback) {
		const self = this;
		if (skuList.length === 0) {
			callback();
		} else {
			const { selectedAccount } = self.props.state.user;
			const accountNumber = selectedAccount.ACCOUNTNUMBER;
			const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
			const pricingCache = self.state.pricingCache;
			skuList.forEach(item => {
				pricingCache.push({
					item,
					agreementNumber,
					callInProgress: true,
					callCompleted: false,
				});
			});
			self.setState({
				pricingCache
			}, () => {
				self.props.checkPricesForSearchResult({
					account_number: accountNumber,
					pricing_effective_date: pricingEffectiveDate,
					sa_number: agreementNumber,
					item_numbers: skuList
				}, showWholeScreenLoader, false, response => {
					response = processPricingResponse(response);
					response.responseObject && response.responseObject.items && response.responseObject.items.forEach(item => {
						item.records = _.filter(item.records, { orderable: "Y"});
					});
					const pricingCache = self.state.pricingCache;
					pricingCache.forEach(item => {
						if(item.agreementNumber === agreementNumber && item.callInProgress === true) {
							const data = response.responseObject.items.find(itm => itm.item_number === item.item);
							item.pricingData = data;
							item.callInProgress = false;
							item.callCompleted = true;
						}
					});
					self.setState({
						pricingCache
					}, () => {
						callback();
					});
				});
			});
		}
	}

	callBackAfterAvailabilityAndPricing(value) {
		const self = this;
		const { isAvailabilityCallCompleted, isPricingCallCompleted, availabilityData, pricingData } = self.state;
		let { suggstionList } = self.state;
		if(isPricingCallCompleted && isAvailabilityCallCompleted) {
			const finalObject = [];
			let updatedSuggestionWithAvailPrice = [];
			suggstionList.responseObject = _.sortBy(suggstionList.responseObject, 'sku');

			if(self.state.isPNETOrNCRP) {
				suggstionList && suggstionList.responseObject.forEach(suggestionItem => {
					const pricingRecord = pricingData.items && _.find(pricingData.items, {item_number: suggestionItem.sku});
					const availabilityRecord = availabilityData && _.find(availabilityData, {inventoryItemName: suggestionItem.sku});
					if (self.props.shipSet === '1' || availabilityRecord) {
						finalObject.push(suggestionItem);
						const updatedItem = {
							...suggestionItem,
							availabilityData: availabilityRecord ? [availabilityRecord] : [],
							pricingData: pricingRecord ? [pricingRecord] : []
						};

						updatedSuggestionWithAvailPrice.push(JSON.parse(JSON.stringify(updatedItem)));
					}
				});
			} else {
				suggstionList && suggstionList.responseObject.forEach(item => {
					const pricingRecord = pricingData.items && _.find(pricingData.items, {item_number: item.sku});
					const availabilityRecord = availabilityData && _.find(availabilityData, {sku: item.sku});
					if(availabilityRecord && pricingRecord) {
						finalObject.push(item);
						if(suggstionList && suggstionList.overpackQuantityRequired){
							item = {
								...item,
								availabilityData: [availabilityRecord],
								pricingData: [pricingRecord],
								overpackQuantityRequired : suggstionList.overpackQuantityRequired,
								packageQuantity : suggstionList.packageQuantity
							};
						}else if(suggstionList && suggstionList.overpackQuantityRequired == undefined && item.overpackQuantityRequired){
							item = {
								...item,
								availabilityData: [availabilityRecord],
								pricingData: [pricingRecord],
								overpackQuantityRequired : item.overpackQuantityRequired,
								packageQuantity : item.packageQuantity
							};
						}else if (suggstionList && suggstionList.responseObject[0] && suggstionList.responseObject[0].overpackQuantityRequired){
							item = {
								...item,
								availabilityData: [availabilityRecord],
								pricingData: [pricingRecord],
								overpackQuantityRequired : item.overpackQuantityRequired,
								packageQuantity : item.packageQuantity
							};
						}else{
							item = {
								...item,
								availabilityData: [availabilityRecord],
								pricingData: [pricingRecord]
							};
						}
						
						updatedSuggestionWithAvailPrice.push(JSON.parse(JSON.stringify(item)));
					}
				});
			}
			
			self.setState({
				showSearchLoading: false,
				showSuggestion: (self.state.isPNETOrNCRP ? self.props.isNewItem || self.props.isAddressChanged || self.state.onChangeOfQuantity : self.state.isImportedFromFile || self.state.onChangeOfSalesAgreement || self.state.onChangeOfQuantity) ? false : true
			}, () => {
				var status = false;
				status = _.find(finalObject, ["sku", value])?true:false;

				updatedSuggestionWithAvailPrice = _.sortBy(updatedSuggestionWithAvailPrice, 'sku');
				if(updatedSuggestionWithAvailPrice && updatedSuggestionWithAvailPrice.length > 5) {
					updatedSuggestionWithAvailPrice = _.chunk(updatedSuggestionWithAvailPrice, 5)[0];
				}
				suggstionList = {
					...suggstionList,
					responseObject: updatedSuggestionWithAvailPrice,
				}
				self.setState({
					productNumberList: self.state.productName.toUpperCase() === suggstionList.keyword.replace("*","").toUpperCase() ? suggstionList : self.state.productNumberList,
				}, () => {
					if (!self.state.isPNETOrNCRP && (self.state.onChangeOfSalesAgreement || self.state.onChangeOfQuantity)) {
						const productDetails = self.state.suggstionList && _.find(self.state.suggstionList.responseObject, ['sku', self.state.productName]);
						if (productDetails && self.state.pricingData.items && self.state.availabilityData)  {
				        	productDetails.status = true;
							self.props.updateQuickOrderState(self.props.itemIndex, {
								...productDetails,
								availabilityData: self.state.isPNETOrNCRP ? self.state.availabilityData.filter(itm => itm.inventoryItemName === self.state.productName) : self.state.availabilityData.filter(itm => itm.sku === self.state.productName),
								pricingData: self.state.pricingData.items.filter(itm => itm.item_number === self.state.productName),
							}, true);
						}
					} else {
						if(self.state.productName.toUpperCase() === suggstionList.keyword.replace("*","").toUpperCase() && !suggstionList.status) {
							self.props.updateQuickOrderState(self.props.itemIndex, { status: status, sku: value });
						} else {
							if(updatedSuggestionWithAvailPrice.length === 1 && updatedSuggestionWithAvailPrice.find(itm => itm.sku === self.state.productName)) {
								if (self.state.isPNETOrNCRP) {
									self.props.updateQuickOrderState(self.props.itemIndex, {availabilityData: updatedSuggestionWithAvailPrice[0].availabilityData && updatedSuggestionWithAvailPrice[0].availabilityData[0],
										pricingData: updatedSuggestionWithAvailPrice[0].pricingData && updatedSuggestionWithAvailPrice[0].pricingData[0]}, true);
								} else {
									self.handleClickOfSuggest(self.state.productName, null);
								}
							} else {
								self.props.updateQuickOrderState(self.props.itemIndex, { status: false, sku: value });
							}
						}
						if(!suggstionList && self.props.onChangeProductNumberTextBox){
							self.props.onChangeProductNumberTextBox(self.props.itemIndex, value, null, true);
						}
					}
				});
			});
		}
	}

	callBackAfterItemOrderabilityAndPricing = () => {
		if (this.state.isAvailabilityCallCompleted && this.state.isPricingCallCompleted) {
			const productDetails = this.state.suggstionList && _.find(this.state.suggstionList.responseObject, ['sku', this.state.productName]);
			const itemAvailabilityData = this.state.availabilityData.filter(itm => itm.sku === this.state.productName);
			const productNumberList = JSON.parse(JSON.stringify(this.state.productNumberList));
			if (productNumberList) {
				productNumberList.responseObject = productNumberList.responseObject && productNumberList.responseObject.map(product => product.sku === this.state.productName ? {...product, availabilityData: itemAvailabilityData} : product);
			}
	
			this.setState({
				productNumberList
			}, () => {
				if (productDetails && this.state.pricingData && this.state.pricingData.items && this.state.availabilityData)  {
					productDetails.status = true;
					this.props.updateQuickOrderState(this.props.itemIndex, {
						...productDetails,
						availabilityData: itemAvailabilityData,
						pricingData: this.state.pricingData.items.filter(itm => itm.item_number === this.state.productName),
					}, true);
				}
			})
		}
	}

    filterSpaces(event) {
        if(event.charCode === 32) event.preventDefault();
    }
	handleKeyDown = e => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
		if (this.state.productNumberList && this.state.productNumberList.responseObject && this.state.productNumberList.responseObject.length) {
			let selectedSuggestedItemIndex = this.state.selectedSuggestedItemIndex;
			switch(e.key) {
				case 'ArrowUp':
					if (selectedSuggestedItemIndex === null) {
						selectedSuggestedItemIndex = 0;
					} else {
						selectedSuggestedItemIndex = selectedSuggestedItemIndex === 0 ? this.state.productNumberList.responseObject.length - 1 : selectedSuggestedItemIndex - 1
					}
					this.setState({
						selectedSuggestedItemIndex,
						showSuggestion: !this.state.showSuggestion ? true : this.state.showSuggestion
					});
					break;
				case 'ArrowDown':
					if (selectedSuggestedItemIndex === null) {
						selectedSuggestedItemIndex = 0;
					} else {
						selectedSuggestedItemIndex = selectedSuggestedItemIndex === this.state.productNumberList.responseObject.length - 1 ? 0 : selectedSuggestedItemIndex + 1
					}
					this.setState({
						selectedSuggestedItemIndex,
						showSuggestion: !this.state.showSuggestion ? true : this.state.showSuggestion
					});
					break;
				case 'Enter':
					const newProduct = this.state.productNumberList.responseObject[this.state.selectedSuggestedItemIndex || 0];
					if (newProduct.sku !== this.state.productName) {
						const sku = newProduct.sku;
						this.handleClickOfSuggest(sku);
					} else {
						if (this.state.showSuggestion) {
							this.setState({
								showSuggestion: false
							});
						}
					}
					break;
				case 'Escape':
					if (this.state.showSuggestion) {
						this.setState({
							showSuggestion: false
						});
					}
					break;
				default:
					break;
			}
		}
    }
    handleClickOfSuggest(sku, event) {
        const self = this;
        event && event.preventDefault();
        self.setState({
            productName: sku,
            showSuggestion: false
        });
		if(!self.state.isPNETOrNCRP && self.state.productNumberList) {
			let productDetails = null;
			let productIndex = null;
			if (self.state.productNumberList.responseObject && self.state.productNumberList.responseObject.length) {
				for (const index in self.state.productNumberList.responseObject) {
					if (self.state.productNumberList.responseObject[index] && self.state.productNumberList.responseObject[index].sku === sku) {
						productIndex = index;
						productDetails = self.state.productNumberList.responseObject[index];
						break;
					}
				}
			}
			self.setState({
				selectedSuggestedItemIndex: productIndex !== null ? +productIndex : productIndex
			}, () => {
				if (!self.state.isStillImportedFromFile && self.props.itemDetails && self.props.itemDetails.qty) {
					self.checkOrderAvailability({ ...self.props.itemDetails, productName: sku }, orderAvailabilityData => {
						self.setState({
							availabilityData: orderAvailabilityData,
							bkpAvailabilityData: JSON.parse(JSON.stringify(orderAvailabilityData))
						}, () => {
							const itemOrderAvailabilityData = orderAvailabilityData.filter(orderAvailabilityItem => orderAvailabilityItem.sku === sku);
							self.props.updateQuickOrderState(self.props.itemIndex, { ...productDetails, availabilityData: itemOrderAvailabilityData }, true);
						})
					})
				}
				productDetails.status = true;
				self.props.updateQuickOrderState(self.props.itemIndex, productDetails, true);
			})
		}
    }
    handleAutoSuggests(flag,event) {
        var self = this,
            value = event.target.value;

        if(self.state.productName !== '' && (self.state.showSearchLoading || !self.state.productNumberList)) {
            event.target.focus();
            return
        }

        setTimeout(function() {
            self.setState({
                showSuggestion: flag
            });
        }, 200);
    }

    render() {
        return (
            <div className="product-number-container">
                <div className="product-number-error-msg"><p className="red"><strong>{this.state.productNumberError}</strong></p></div>
                <input type="text" name="ProdSearchName"
                    onChange={this.handleChangeProductNumber.bind(this)}
					ref={(input) => this.suggestInput = input}
                    className="row_product outsideProdSearchName"
                    onKeyPress={this.filterSpaces.bind(this)}
					onKeyDown={this.handleKeyDown}
                    onBlur={this.handleAutoSuggests.bind(this, false)}
                    onFocus={this.handleAutoSuggests.bind(this, true)}
                    style={{width: this.props.width?this.props.width:300}}
                    autoComplete="off"
                    value={this.state.productName}
					size={this.props.size?this.props.size:''}
                />
                {(this.state.showSearchLoading || this.state.productNumberList) && <div id="product-number-autocomplete" style={{zIndex: 101}} className={(this.state.showSuggestion && this.state.productName !== "" && !this.state.isStillImportedFromFile ? "show" : "hide")}>
					{this.state.showSearchLoading
						?<div><br/><div className="loader">&#160;</div><br/></div>
						:null
					}
                    {!this.state.showSearchLoading && this.state.productNumberList && this.state.productNumberList.responseObject && this.state.productNumberList.status === true && this.state.productNumberList.responseObject.map((item, index) => {
                        return <a className={this.state.selectedSuggestedItemIndex === index ? 'active' : undefined} tabIndex="-1" key={index} onClick={this.handleClickOfSuggest.bind(this, item.sku)} href="">{item.sku}</a>
                    })}
					{!this.state.showSearchLoading && this.state.productNumberList && this.state.productNumberList.responseObject && this.state.productNumberList.status === true && this.state.productNumberList.responseObject.length === 0 &&
						<div>{this.state.isPNETOrNCRP && this.state.partSearchErrorMessages && this.state.partSearchErrorMessages.length ? this.state.partSearchErrorMessages.map((partsSearchErrorMessage, index) => <React.Fragment key={index}><br />{partsSearchErrorMessage}</React.Fragment>) : <React.Fragment><br/>No results found.</React.Fragment>}<br/><br/></div>
					}
            	</div>}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
  return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getSearchKeywordSuggestionList: (queryStringParams, callback) => dispatch(getSearchKeywordSuggestionList(queryStringParams, callback)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
});

AccountNumberAutoSuggests = connect(mapStateToProps, mapDispatchToProps)(AccountNumberAutoSuggests);
export default AccountNumberAutoSuggests;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/accountNumberAutoSuggestsAvailPricing.js